import React, { useState } from "react";

export const NewFormBlock = ({ languageData, addAction, loadingState, placeholderText, buttonLabel, buttonClass = "ElementButton", prefix = null, syfix = null }) => {

    const nameCode = 'name_' + languageData.code;

    const [inputValue, setInputValue] = useState({ [nameCode]: '' })

    const newValueHandler = event => {
        setInputValue({ ...inputValue, [event.target.name]: event.target.value, language: languageData.code })
        // console.log(inputValue);
    }

    return (
        <form className="FormBlock w-100">
            <div key={languageData.code} className="FormBlockElement align-items-center">
                <span className="text-white">{prefix ?? null}</span>
                <input type="text" className="FormInput BoxShadow"
                    placeholder={placeholderText} name={nameCode}
                    onChange={newValueHandler}
                    value={inputValue[nameCode]}
                    style={languageData.code === "he" ? { direction: "rtl", textAlign: "right" } : null} />
                {syfix ? <span className="text-white ml-3">{syfix ?? null}</span> : null}
                <button type="submit" className={buttonClass} disabled={loadingState}
                    onClick={(e) => {
                        e.preventDefault();
                        if (inputValue[nameCode]?.length) {
                            addAction(inputValue);
                            setInputValue({ [nameCode]: '' });
                        }
                    }}>
                    {buttonLabel}
                </button>
            </div>
        </form >
    )
};
